import { DreamValue } from '@/sharedComponents/TextEditor/plate';
import { ICollectionData } from '@/types';
import { cloneDeep } from 'lodash';

export function extractCollectionIDsFromContent(content: DreamValue) {
  const collectionIDs = new Set<string>();
  content.forEach((block) => {
    if (block.type === 'collection' || block.type === 'collection_cms') {
      collectionIDs.add(block.collection_data_id);
      return;
    }
    if (block.children) {
      extractCollectionIDsFromContent(block.children as DreamValue).forEach((id) => {
        collectionIDs.add(id);
      });
    }
  });
  return collectionIDs;
}

// pruneUnusedCollectionData removes all collection data that is not used in a page's content
export const pruneUnusedCollectionData = (
  current: ICollectionData,
  content: DreamValue
): ICollectionData => {
  const ids = extractCollectionIDsFromContent(content);
  if (ids.size === 0) {
    return current;
  }

  // remove everything that is not included in ids
  const newCurrent = cloneDeep(current);
  Object.keys(current).forEach((key) => {
    if (!ids.has(key)) {
      delete newCurrent[key];
    }
  });

  return newCurrent;
};
